import { createSlice } from "@reduxjs/toolkit";

export const reportSlice = createSlice({
  name: "report",
  initialState: {
    reports: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getReportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getReportSuccess: (state, action) => {
      state.isFetching = false;
      state.reports = action.payload;
    },
    getReportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    // UPDATE
    updateAppointmentStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateAppointmentSuccess: (state, action) => {
      console.log(action.payload, 'payload in service')
      state.isFetching = false;
      state.appointments[
        state.appointments.findIndex((item) => item._id === action.payload.id)
      ] = action.payload.category;
    },
    updateAppointmentFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  getReportStart,
  getReportSuccess,
  getReportFailure,
  updateAppointmentStart,
  updateAppointmentSuccess,
  updateAppointmentFailure,
} = reportSlice.actions;

export default reportSlice.reducer;
